import React from 'react'
import PropTypes from 'prop-types'
import { sanitizeHTML } from '../../helpers/utils'
import styled from 'styled-components'

const Box = styled.div(({ style }) => {
  return {
    paddingBottom: '30px',
    a: {
      color: 'var(--white) !important'
    },
    h2: {
      color: 'inherit',
      fontSize: '18px',
      fontWeight: 700,
      marginBottom: '0',
      paddingBottom: '20px'
    },
    p: {
      fontSize: '12px'
    },
    ...style
  }
})

const vStyle = {
  v2: {},
  v3: {},
  v4: {
    a: {
      color: 'var(--dark) !important',
      textDecoration: 'underline'
    }
  }
}

const FooterText = ({ text, version, ...rest }) => {
  const style = vStyle[version] || {}
  return (
    <React.Fragment>
      <Box
        style={style}
        {...rest}
        dangerouslySetInnerHTML={{
          __html: sanitizeHTML(text)
        }}
      />
    </React.Fragment>
  )
}

FooterText.propTypes = {
  text: PropTypes.string.isRequired,
  version: PropTypes.string
}

export default FooterText



// WEBPACK FOOTER //
// ./src/components/Footer/FooterText.js